import styled from '@emotion/styled'
import { Stack } from '@pubstack/common/src/stack'
import { FunctionComponent } from 'react'
import { Colors } from '~/assets/style/colors'
import { Fonts } from '~/assets/style/fonts'
import { BaseInputElement } from '~/components/Input'
import { Slider } from '~/components/Slider'

const AbDeploySlider = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`

const InputRatio = styled(BaseInputElement)`
  ${Fonts.P1}

  input {
    padding: 0.125rem 0;
  }
`

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`

const Flex = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`

const AbTestInfo = styled.p`
  font-style: italic;
  ${Fonts.P2};
  color: ${Colors.Hurricane};
`

type Props = {
  stack: Stack
  liveStack: Stack
  ratio: number // 0-1
  onChange: (ratio: number) => void
}

export const AbDeploySetRatiosTable: FunctionComponent<Props> = ({ stack: _stack, liveStack, ratio, onChange }) => {
  const ratioPercent = Math.round(ratio * 100)
  const liveRatioPercent = 100 - ratioPercent

  const handleChange = (value: number) => {
    onChange(+(value / 100).toFixed(2))
  }

  return (
    <Wrapper>
      <Flex>
        <span>Deploy this stack on</span>
        <AbDeploySlider>
          <Slider value={ratioPercent} min={1} max={100} step={1} onChange={handleChange} />
          <InputRatio
            type="number"
            min={1}
            max={100}
            iconRight="percent"
            isClearable={false}
            value={String(ratioPercent)}
            onKeyDown={(e) => {
              if (['e', '-', '+', ',', '.'].includes(e.key)) e.preventDefault()
            }}
            onChange={(event) => {
              const value = Number(event.target.value)
              handleChange(isNaN(value) ? 1 : Math.min(100, Math.max(1, value)))
            }}
          />
        </AbDeploySlider>
        <span>of the traffic.</span>
      </Flex>
      {liveRatioPercent > 0 && liveRatioPercent < 100 && (
        <AbTestInfo>
          {liveStack.name} v{liveStack.version} will be deployed on {liveRatioPercent}% of the traffic.
        </AbTestInfo>
      )}
    </Wrapper>
  )
}
